import React, { useEffect, useState } from "react";
import "../Navbar.css";

const NavBar = () => {
  const [darkMode, SetDarkMode] = useState(false);
  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [darkMode]);

  return (
    <nav
      className={`navbar navbar-expand-lg ${
        darkMode ? "navbar-dark bg-dark" : "navbar-light bg-light"
      }shadow-sm`}
      style={{
        borderBottom: darkMode
          ? "1px solid rgba(255, 255, 255, 0.15)"
          : "1px solid rgba(0, 0, 0, 0.2)",
      }}
    >
      <div className="container">
        <a
          className="navbar-brand fw-bold text-primary d-flex align-items-center gap-2"
          href="#home"
        >
          <i
            className="bi bi-car-front-fill"
            style={{ fontSize: "40px", color: "green" }}
          ></i>
          <span style={{ color: darkMode ? "orangered" : "#0d6efd" }}>
            CarRental
          </span>
        </a>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className="nav-link cool-hover" href="/#home">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link cool-hover" href="/#cars">Cars</a>
            </li>
             <li className="nav-item">
              <a className="nav-link cool-hover" href="/#rentcar">Rent Car</a>
            </li>
            <li className="nav-item">
              <a className="nav-link cool-hover" href="/#about">About</a>
            </li>
            <li className="nav-item">
              <a className="nav-link cool-hover" href="/#contact">Contact</a>
            </li>
            <li className="nav-item">
              <button className="btn fancy-btn ms-3">Sign In</button>
            </li>
            <li className="nav-item">
              <button className="btn fancy-btn ms-3">Sign Up</button>
            </li>
            <li className="nav-item ms-3">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="darkModeSwitch"
                  checked={darkMode}
                  onChange={() => SetDarkMode(!darkMode)}
                />
                <label
                  className={`form-check-label ${
                    darkMode ? "text-light" : "text-dark"
                  }`}
                  htmlFor="darkModeSwitch"
                >
                  {darkMode ? "Dark" : "Light"}
                </label>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
